import { LoaderResult } from '@nexelem/navigation';
import { isEqual } from 'lodash';
import { useEffect, useState } from 'react';
import { useAsyncValue, useMatches, useRouteLoaderData } from 'react-router-dom';

export function useLoaderData<T>(routeId: string): T | null {
  const matches = useMatches();
  const data = useAsyncValue();

  const { result } = (useRouteLoaderData(routeId) || {}) as LoaderResult<T>;

  const [loadedData, setLoadedData] = useState<T | null>(() => {
    const nearestMatch = matches.at(-1);
    if (nearestMatch?.id === routeId) {
      return data as T;
    }
    return null;
  });

  useEffect(() => {
    if (result) {
      result.then((newData) => setLoadedData((prevState) => (!isEqual(prevState, newData) ? newData : prevState)));
    }
  }, [result]);

  return loadedData;
}
